import type { IDownloadListReportPayload } from '@modules/download-report/types';
import { useRestClient } from '@modules/core/services/api';
import { useContextMutation } from '@modules/core/services/query';
import {
  DOWNLOAD_PLAYERS_REPORT_API_URL,
  DOWNLOAD_PLAYERS_REPORT_MUTATION_KEY,
  PLAYERS_PERMISSIONS,
} from '@modules/players/constants';

export default function useDownloadPlayersReportMutation(): ReturnType<
    typeof useContextMutation<void, Error, IDownloadListReportPayload>
> {
  const { fetchPost } = useRestClient();

  return useContextMutation<void, Error, IDownloadListReportPayload>({
    mutationKey: [DOWNLOAD_PLAYERS_REPORT_MUTATION_KEY],
    mutationFn: (payload) => fetchPost<void>(
      DOWNLOAD_PLAYERS_REPORT_API_URL,
      payload,
      { permission: PLAYERS_PERMISSIONS.DOWNLOAD_PLAYERS_LIST },
    ),
  });
}
